import { createStyles } from "@mantine/core";

const useStyles = createStyles((theme) => ({
  greetingsParentClass: {
    margin: "1rem",
    padding: "10px",
  },
  welcomeHeading: {
    margin: "0",
    fontWeight: "normal",
    lineHeight: "30px",
  },
  smallText: {
    color: "#A3A3A3",
  },
}));

export default useStyles;
